import React, { Component } from 'react';

import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class DeleteTemplateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            selectedTemplate: props.selectedTemplate
        };
    }

    deleteTemplate = async () => {

        const { orgId, eventId, toggle } = this.props;
        const { selectedTemplate } = this.state;
        await API().patch(`Organizations/${orgId}/events/${eventId}/viewReports/${selectedTemplate._id}`, { isOrgTemplate: false })
            .then((res) => {
                if (res.data) {
                    this.props.updateRemoveOrgTemplate(selectedTemplate._id)

                    toggle();
                }
            });
    };

    render() {
        const { isOpen, toggle, } = this.props;
        const { submitting, selectedTemplate } = this.state;
        return (
            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Delete Report Template"}
                    bodyHeaderText={`Are you sure you want to delete ${selectedTemplate.name}? This can not be undone.`}
                    bodyDescription={''}
                    bodyContent={() => {
                        return ('')
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Delete' : 'Deleting...'}
                    actionButton={() => this.deleteTemplate()}
                    actionButtonDisabled={submitting}
                    isDelete={true}
                ></FieldModal>
            </div>

        );
    }
}

export default DeleteTemplateModal;
